<template>
  <div>
    <h4>Exibição</h4>
    <div class="row no-gutters p-0 mb-3">
      <b-col cols="12">
        <label class="d-flex p-3 cursor-pointer border rounded-lg mb-3">
          <b-form-checkbox
            v-model="modelValue.status"
            :value="true"
            :unchecked-value="false"
          />
          Ciclo ativo?
        </label>
      </b-col>
      <b-col cols="12">
        <label class="d-flex p-3 cursor-pointer border rounded-lg mb-3">
          <b-form-checkbox
            v-model="modelValue.is_default"
            :value="true"
            :unchecked-value="false"
          />
          Definir como ciclo padrão?
        </label>
      </b-col>
      <b-col cols="12">
        <h4 class="mt-3">Período</h4>
        <b-form-group class="radio-selector" v-slot="{ ariaDescribedby }">
          <b-form-radio-group
            v-model="modelValue.periodicidade"
            :options="periodicidadeOptions"
            :aria-describedby="ariaDescribedby"
            name="periodicidade-options"
          />
          <b-form-invalid-feedback :state="validateState('periodicidade')">
            Este campo é obrigatório.
          </b-form-invalid-feedback>
        </b-form-group>
      </b-col>
    </div>

    <h4>Descontos por meio de pagamento</h4>
    <div class="row border rounded-lg pt-3 pb-5 px-2 mx-0 mb-3">
      <h5 class="col-12">
        <font-awesome-icon icon="barcode" />
        Boleto
      </h5>
      <input-wrap-row
        class="col-12"
        operation-icon="minus"
        result-icon="arrow-right-arrow-left"
      >
        <template #first>
          <b-form-group label="Valor base" class="mb-0">
            <b-form-input
              :value="formattedBaseValue"
              placeholder="R$ 0,00"
              readonly
            />
          </b-form-group>
        </template>

        <template #second>
          <b-form-group label="Desconto boleto (%)" class="mb-0">
            <NumberFormat
              v-model.number="modelValue.desconto_boleto"
              :decimals="2"
              min="0"
              max="99"
              placeholder="Ex: 5,00"
              :state="validateState('desconto_boleto')"
            />
            <sugestion-line-hint
              v-model="modelValue.desconto_boleto"
              :sugestions="discountSuggestions"
            />
          </b-form-group>
        </template>

        <template #result>
          <b-form-group label="Valor no boleto" class="mb-0">
            <NumberFormat
              v-model.number="boleto"
              placeholder="Ex: 100,00"
              @blur="normalizarDesconto('desconto_boleto')"
            />
          </b-form-group>
        </template>
      </input-wrap-row>
      <hr class="hr col my-5 w-100" />
      <h5 class="col-12">
        <font-awesome-icon :icon="['fab', 'pix']" />
        Pix
      </h5>
      <input-wrap-row
        class="col-12"
        operation-icon="minus"
        result-icon="arrow-right-arrow-left"
      >
        <template #first>
          <b-form-group label="Valor base" class="mb-0">
            <b-form-input
              :value="formattedBaseValue"
              placeholder="R$ 0,00"
              readonly
            />
          </b-form-group>
        </template>

        <template #second>
          <b-form-group label="Desconto pix (%)" class="mb-0">
            <NumberFormat
              v-model.number="modelValue.desconto_pix"
              :decimals="2"
              min="0"
              max="99"
              placeholder="Ex: 5,00"
              :state="validateState('desconto_pix')"
            />
            <sugestion-line-hint
              v-model="modelValue.desconto_pix"
              :sugestions="discountSuggestions"
            />
          </b-form-group>
        </template>

        <template #result>
          <b-form-group label="Valor no pix" class="mb-0">
            <NumberFormat
              v-model.number="pix"
              placeholder="Ex: 100,00"
              @blur="normalizarDesconto('desconto_pix')"
            />
          </b-form-group>
        </template>
      </input-wrap-row>
      <hr class="hr col my-5 w-100" />
      <h5 class="col-12">
        <font-awesome-icon :icon="['far', 'credit-card']" />
        Cartão de crédito
      </h5>
      <input-wrap-row
        class="col-12 mb-3"
        operation-icon="minus"
        result-icon="arrow-right-arrow-left"
      >
        <template #first>
          <b-form-group label="Valor base" class="mb-0">
            <b-form-input
              :value="formattedBaseValue"
              placeholder="R$ 0,00"
              readonly
            />
          </b-form-group>
        </template>

        <template #second>
          <b-form-group label="Desconto cartão de crédito (%)" class="mb-0">
            <NumberFormat
              v-model.number="modelValue.desconto_cc"
              :decimals="2"
              min="0"
              max="99"
              placeholder="Ex: 5,00"
              :state="validateState('desconto_cc')"
            />
            <sugestion-line-hint
              v-model="modelValue.desconto_cc"
              :sugestions="discountSuggestions"
            />
          </b-form-group>
        </template>

        <template #result>
          <b-form-group label="Valor no cartão de crédito" class="mb-0">
            <NumberFormat
              v-model.number="cartao"
              placeholder="Ex: 100,00"
              @blur="normalizarDesconto('desconto_cc')"
            />
          </b-form-group>
        </template>
      </input-wrap-row>

      <input-wrap-row class="col-12 mb-3" result-icon="equals">
        <template #second>
          <b-form-group label="Parcelamento máximo" class="mb-0">
            <NumberFormat
              v-model.number="modelValue.parcelas_credito"
              placeholder="Ex: 12"
              :decimals="0"
              :state="validateState('parcelas_credito')"
            />
            <b-form-invalid-feedback :state="validateState('parcelas_credito')">
              Este campo é obrigatório.
            </b-form-invalid-feedback>
            <sugestion-line-hint
              v-model="modelValue.parcelas_credito"
              :sugestions="installmentSuggestions"
            />
          </b-form-group>
        </template>
        <template #result>
          <b-form-group label="Valor da parcela" class="mb-0">
            <b-form-input
              :value="formattedParcela"
              placeholder="Ex: 100,00"
              readonly
            />
          </b-form-group>
        </template>
      </input-wrap-row>
    </div>
  </div>
</template>

<script>
import { computed, defineComponent, ref, watch } from "vue";
import cloneDeep from "lodash/cloneDeep";

import InputWrapRow from "@/components/Form/InputWrapRow.vue";
import NumberFormat from "@/components/Form/NumberFormat.vue";
import SugestionLineHint from "@/components/Form/SugestionLineHint.vue";
import { getEmptyPeriodicidade } from "@/modules/planos/Components/Form/getEmptyPeriodicidade";
import { safeArray } from "@/helpers/functions/ArrayHelpers";
import { getPeriodicidades } from "@/modules/planos/Components/Form/getPeriodicidades";
import { maxValue, minValue, required } from "@vuelidate/validators";
import useVuelidate from "@vuelidate/core";
import { useVModel } from "@vueuse/core";
import { useNotify } from "@/composables/useNotify";
import number_format from "@/helpers/filters/number_format";
import { useCalcDesconto } from "@/modules/planos/composables/useCalcDesconto";
import { calcParcelas } from "@/modules/planos/helpers/calcParcelas";
import { roundMoney } from "@/modules/planos/helpers/roundMoney";

export default defineComponent({
  components: { InputWrapRow, NumberFormat, SugestionLineHint },
  props: {
    value: {
      type: Object,
      default: () => getEmptyPeriodicidade(),
    },
    baseValue: {
      type: Number,
      default: 0,
    },
    activePeriodicities: {
      type: Array,
      default: () => [],
    },
  },
  setup(props, { emit }) {
    const modelValue = useVModel(props, "value", emit);
    const isActivePeriodicity = ref("");
    const $notifications = useNotify();

    const rules = {
      periodicidade: { required },
      valor_boleto: { required },
      valor_pix: { required },
      valor_cc: { required },
      parcelas_credito: { required },
      desconto_boleto: { required, max: maxValue(100), min: minValue(0) },
      desconto_pix: { required, max: maxValue(100), min: minValue(0) },
      desconto_cc: { required, max: maxValue(100), min: minValue(0) },
    };

    const discountSuggestions = [5, 10, 15, 20].map((value) => ({
      text: `${value}%`,
      value,
    }));

    const installmentSuggestions = [1, 2, 3, 6, 12].map((value) => ({
      text: `${value}x`,
      value,
    }));

    const v$ = useVuelidate(rules, modelValue);

    const periodicidadeOptions = computed(() => {
      const current = isActivePeriodicity.value;
      const actives = safeArray(props.activePeriodicities);

      return getPeriodicidades().map((periodicity) => {
        const isActive = current !== periodicity.value;

        periodicity.disabled = isActive && actives.includes(periodicity.value);

        return periodicity;
      });
    });

    const currentPeriodicidadeMonths = computed(() => {
      const selectedValue = modelValue.value?.periodicidade;
      const findByCurrent = (item) => item.value === selectedValue;

      const current = getPeriodicidades().find(findByCurrent);

      return Number(current?.months ?? 0);
    });

    const baseValueRef = computed(() => Number(props.baseValue ?? 0));

    const currentBaseValue = computed(() =>
      roundMoney(currentPeriodicidadeMonths.value * baseValueRef.value)
    );

    const formattedBaseValue = computed(
      () => `R$ ${number_format(currentBaseValue.value)}`
    );

    function validateState(name) {
      const { $dirty, $error } = v$.value?.[name];
      return $dirty ? !$error : null;
    }

    async function isValid() {
      const isValid = await v$.value.$validate();
      return isValid;
    }

    function reset() {
      modelValue.value = getEmptyPeriodicidade();
      v$.value.$reset();
    }

    // A API grava o desconto com 2 casas (decimal 5,2). Ao digitar o valor final, o percentual
    // derivado tem mais casas; arredondá-lo faz o valor exibido ser exatamente o que será cobrado.
    function normalizarDesconto(field) {
      modelValue.value[field] = roundMoney(modelValue.value?.[field] ?? 0);
    }

    async function save() {
      ["desconto_boleto", "desconto_pix", "desconto_cc"].forEach(
        normalizarDesconto
      );

      const isValidData = await isValid();

      if (!isValidData) {
        $notifications.addNotification({
          message: "Os dados do formulário são inválidos",
          type: "danger",
        });
        return null;
      }

      return cloneDeep(modelValue.value);
    }

    watch(
      () => props.value?.id,
      (value) =>
        !!value && (isActivePeriodicity.value = modelValue.value.periodicidade),
      {
        immediate: true,
      }
    );

    function numericModelRef(field) {
      return computed({
        get: () => Number(modelValue.value?.[field] ?? 0),
        set: (value) => {
          modelValue.value[field] = Number(value ?? 0);
        },
      });
    }

    function createDiscountModel(percentField, finalValueField) {
      return useCalcDesconto({
        percent: numericModelRef(percentField),
        baseValue: currentBaseValue,
        finalValue: numericModelRef(finalValueField),
      });
    }

    const boleto = createDiscountModel("desconto_boleto", "valor_boleto");
    const pix = createDiscountModel("desconto_pix", "valor_pix");
    const cartao = createDiscountModel("desconto_cc", "valor_cc");

    const valorParcela = computed(() =>
      calcParcelas({
        value: cartao.value,
        installments: Number(modelValue.value?.parcelas_credito ?? 0),
      })
    );

    const formattedParcela = computed(
      () => `R$ ${number_format(valorParcela.value)}`
    );

    return {
      modelValue,
      boleto,
      pix,
      cartao,
      valorParcela,
      formattedParcela,
      periodicidadeOptions,
      formattedBaseValue,
      discountSuggestions,
      installmentSuggestions,
      isValid,
      reset,
      save,
      validateState,
      normalizarDesconto,
    };
  },
});
</script>
<style scoped lang="scss">
.radio-selector {
  [role="radiogroup"] {
    height: auto;
    border: 1px solid rgba(var(--deep-blue-rgb), 0.1);
    border-radius: 0.5rem;
    display: inline-flex;
    gap: 0.25rem;
  }
}

::v-deep .custom-control-inline.custom-radio {
  padding-left: 2.5rem;
  margin-right: 0;
  padding-right: 0.75rem;

  &:not(:last-of-type) {
    border-right: 1px solid rgba(var(--deep-blue-rgb), 0.1);
  }

  &:hover {
    color: var(--primary);
  }

  .custom-control-input:checked ~ .custom-control-label {
    color: var(--primary);
  }
  .custom-control-label {
    display: inline-block;
    vertical-align: middle;

    span {
      padding: 0.5rem 0.25rem;
      display: block;
    }
  }

  .custom-control-label::before,
  .custom-control-label::after {
    left: calc(2.5rem * -0.65);
    top: 10px;
  }
}

::v-deep .custom-control.custom-checkbox {
  padding-left: 2.5rem;

  .custom-control-label::before,
  .custom-control-label::after {
    left: -1.95rem;
  }
}

.custom-form-input-result {
  .form-control {
    background-color: rgba(var(--deep-blue-rgb), 0.1) !important;
    border-color: rgba(var(--exitos-rgb), 0.25);

    &:focus {
      color: var(--deep-blue);
    }
  }
}
</style>
